import React from 'react'
import { Text } from "@fluentui/react";
//import "office-ui-fabric-react/dist/css/fabric.css";

function StadisticCard(props) {

    //Parametros de entrada.
    const inputParam_Item = props.item !== null && props.item !== undefined ? props.item : null;
    const inputParam_ArrayLength = props.arrayLength !== null && props.arrayLength !== undefined ? props.arrayLength : 0;
    const inputParam_Index = props.index !== null && props.index !== undefined ? props.index : 0;

    const styles = {
        header: {
            root: {
                fontSize: 12,
                fontWeight: "bold",
                padding: "10px"
            }
        },
        amount: {
            root: {
                fontSize: "20px",
                verticalAlign: "middle",
            }
        }
    };
    return (
            <div index={inputParam_Index} length={inputParam_ArrayLength}  style={{borderRight: inputParam_ArrayLength > inputParam_Index ? "1px solid #b7b7b7" : ""}}>
                <div style={{display: inputParam_Item.display ? "block" : "none"}} className="mx-2">
                    <div className="text-center">
                        <i style={{ fontSize: 20, verticalAlign: "middle", color: inputParam_Item.color}} className={ `ms-Icon ms-Icon--${inputParam_Item.icon}` } ></i>
                        <Text className="ps-2" styles={styles.amount}>{inputParam_Item.amount}</Text>
                    </div>
                    <div style={{fontSize: "small", whiteSpace : "nowrap"}} className="text-center">
                        {inputParam_Item.title}
                    </div>
                </div>
            </div>
    );
}

export default StadisticCard;

